import { Clock, Award, ChevronRight } from "lucide-react";
import { cn } from "../../app/BusinessDash/lib/utils";

export const CourseCard = ({ course, isSelected, onClick }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "w-full text-left p-2 rounded-lg border-2 transition-all duration-200",
        "hover:border-tier-education/60 hover:bg-tier-education/5",
        isSelected
          ? "border-tier-education bg-tier-education/10"
          : "border-border/50 bg-card/50"
      )}
      style={{ fontSize: "0.75rem" }}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-foreground text-xs leading-tight mb-0.5 line-clamp-1">
            {course.title}
          </h4>
          <p className="text-[10px] text-muted-foreground line-clamp-1">
            {course.shortDescription}
          </p>
          <div className="flex items-center gap-2 mt-1 text-[10px] text-muted-foreground">
            <span className="flex items-center gap-0.5">
              <Clock className="h-2.5 w-2.5" />
              {course.duration}
            </span>
            <span className="flex items-center gap-0.5">
              <Award className="h-2.5 w-2.5" />
              {course.ects} ECTS
            </span>
          </div>
        </div>
        <ChevronRight className={cn(
          "h-4 w-4 text-muted-foreground transition-colors shrink-0 mt-0.5",
          isSelected && "text-tier-education"
        )} />
      </div>
    </button>
  );
};

